/* Click-to-load video. No iframe, autoplay, or audio before user intent. */
(() => {
  const init = () => document.querySelectorAll('[data-tsh-video]').forEach(root => {
    if(root.dataset.videoBound)return;
    root.dataset.videoBound='true';
    root.querySelector('.tsh-video-trigger')?.addEventListener('click',() => {
      const id=root.dataset.tshVideo;
      if(!/^[\w-]{11}$/.test(id))return;
      const frame=document.createElement('iframe');
      frame.src=`https://www.youtube-nocookie.com/embed/${id}?autoplay=1&rel=0`;
      frame.title=root.dataset.videoTitle||'The Stronger Human video';
      frame.allow='autoplay; encrypted-media; picture-in-picture; fullscreen';
      frame.referrerPolicy='strict-origin-when-cross-origin';
      frame.allowFullscreen=true;
      root.replaceChildren(frame);
      frame.focus();
    },{once:true});
  });
  document.addEventListener('shopify:section:load',init);
  init();
})();
